export default __webpack_public_path__ + "static/media/women-big.352ae475.png";